import React from 'react';
import useStyles from './RatingChecklist.styles';
import clsx from 'clsx';
import { get, size } from 'global/lib/lodash';
import { getColorFromValue } from 'global/styles';
import { useLocation } from 'react-router-dom';
import { getUrlParams } from 'global/utils';
import { useScreen } from 'global/styles';
import { Column } from 'global/components/row';
import { ImageList } from 'global/components/image';
import { Box } from '@material-ui/core';

const percentify = (cols) => {
  return `${(1 / size(cols)) * 100}%`;
};

const RatingRow = (props) => {
  const { cols } = props;
  const classes = useStyles();

  return (
    <div className={classes.ratingRow}>
      <div className={clsx(classes.cpName, classes.textCol)} />
      {cols.map((c, i) => (
        <div className={classes.col} style={{ backgroundColor: c.color, width: percentify(cols) }}>
          {c.title}
        </div>
      ))}
    </div>
  );
};

export default (props) => {
  const loca = useLocation();
  const { checklist, editMode, optionVals } = props;
  const { checkpoints } = checklist;
  const { isDown } = useScreen('xs');

  // TO-DO: Add meta value into Edition that defines min/max values, to allow customization
  // We differentiate display between 0-4 and % by evaluating the options
  const cols =
    [...new Set([...optionVals, ...[0, 25, 50, 75, 80, 100]])].length === 6 && optionVals.length > 2
      ? optionVals.sort((a, b) => a - b).map((v, i) => ({ title: v / 25, value: v, color: getColorFromValue(v) }))
      : optionVals.sort((a, b) => a - b).map((v, i) => ({ title: v + '%', value: v, color: getColorFromValue(v) }));

  const classes = useStyles({ isMobile: isDown });

  const params = getUrlParams(loca.search);

  const sortCheckpoints = (a, b) => {
    return a.name.localeCompare(b.name);
  };

  return (
    <>
      {!isDown && <RatingRow cols={cols} />}

      {(checkpoints || []).sort(sortCheckpoints).map((cp, i) => {
        const { images } = cp;
        const bg = i % 2;
        const highlight = get(params, 'hl') === cp.id;

        return (
          <Column key={i} className={classes[`cp_${bg}`]} style={{ alignItems: 'flex-start' }}>
            <div className={clsx(classes.cpRow, highlight && classes.hlRow)}>
              <div className={clsx(classes.cpName, classes.textCol)}>{cp.name}</div>

              <div className={classes.ratingWrap}>
                {cols.map((c, _i) => {
                  const hasVal = get(cp, 'checkpointOptions', []).find((cpo) => cpo.value === c.value);

                  if (isDown) {
                    return (
                      <div key={_i} className={clsx(classes.ratingRow, classes.textSmall)}>
                        {isDown && (
                          <div className={classes.colMobile} style={{ backgroundColor: c.color }}>
                            {c.title}
                          </div>
                        )}
                        <div className={classes.textCol}>{get(hasVal, 'name', '')}</div>
                      </div>
                    );
                  }

                  return (
                    <div key={_i} className={clsx(classes.col, classes.textCol, classes.textSmall)} style={{ width: percentify(cols) }}>
                      {get(hasVal, 'name', '')}
                    </div>
                  );
                })}
              </div>
            </div>
            <div style={{ width: isDown ? '100%' : '50%' }}>
              {!editMode && !!size(images) && !props.printView && (
                <Box displayPrint="none" className={classes.row}>
                  <ImageList displayAsLink images={cp.images} />
                </Box>
              )}
              {!!editMode && props.renderForm(cp, i)}
            </div>
          </Column>
        );
      })}
    </>
  );
};
